import {
	getSearchModule,
	getVersionsModule,
} from '../../../Infrastructure/Store/systems-module/systems-module.action';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import { select, Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import {
	deleteModule,
	deleteResourceModule,
	getAllModule,
	getResourcesModule,
} from 'projects/access-control/src/app/Infrastructure/Store/systems-module/systems-module.action';
import { MatDialog } from '@angular/material/dialog';
import { ModalNewModuleComponent } from '../../components/modal-new-module/modal-new-module.component';
import { OptionsTable } from 'projects/access-control/src/app/Domain/Entities/options-table.interface';
import { ModalAddResourceComponent } from 'projects/access-control/src/app/UI/components/modal-add-resource/modal-add-resource.component';
import { Module } from 'projects/access-control/src/app/Domain/Entities/module.interface';
import FilterList, {
	FilterValues,
	OptionsFilter,
} from 'projects/access-control/src/app/Domain/Entities/filter-list.interface';
import filtersResourceTable from './components/resources/filtersResourceTable';
import { TranslateService } from '@mangosoft/mango-layout';
import { DataTranslatePages } from 'projects/access-control/src/app/Domain/Entities/data-translate-pages';
import { FilterTablePipe } from 'projects/access-control/src/app/Infrastructure/pipes/filter-table.pipe';
import { Resource } from 'projects/access-control/src/app/Domain/Entities/resource-interface';
import { IPkSk } from 'projects/access-control/src/app/Domain/Entities/roles/role.interface';
import { SortPipe } from 'projects/access-control/src/app/Infrastructure/pipes/orderBy.pipe';
import { DataPagination } from 'projects/access-control/src/app/Domain/Adapters';
import { setModule } from 'projects/access-control/src/app/Infrastructure/Store/systems-module/systems-module.selectors';
import { FiltersService } from 'projects/access-control/src/app/Infrastructure/Services/filters/filters.service';
import { environment } from 'projects/access-control/src/environments/environment';
import { Tabs } from 'projects/access-control/src/app/Domain/Entities/tabs.interface';
import { Versions } from 'projects/access-control/src/app/Domain/Entities/versions.interface';

interface translateSystemModules extends DataTranslatePages {
	buttonResource: string;
	delete: string;
	deleteResource: string;
	deleteBulkResource: string;
	textNotSelected: string;
	buttonDelete: string;
	buttonEdit: string;
	hoverButtonNew: string;
	columnsFilter: { name: string; label: string }[];
	tabs: Tabs[];
	table: {
		name: string;
		action: string;
		path: string;
		actions: string;
	};
	searchTable: FilterList[];
}
@Component({
	selector: 'app-system-modules',
	templateUrl: './system-modules.component.html',
	styleUrls: ['./system-modules.component.scss'],
})
export class SystemModulesComponent implements OnInit, OnDestroy {
	@Input() id!: string;
	showSearch = false;
	elementsDelete: string = '';
	openAlert: boolean = false;
	rows: Resource[] = [];
	rowsFilter: Resource[] = [];
	paginationModule: DataPagination = {} as DataPagination;
	paginationResource: DataPagination = {} as DataPagination;
	paginationVersion: DataPagination = {} as DataPagination;
	isLoadingVersions = false;

	modalEdit: any = {};
	modules: Module[] = [];
	rowsLength!: number;
	selectionType = SelectionType;
	subscriptionCampagin!: Subscription;
	subscriptionModule!: Subscription;
	subscriptionResources!: Subscription;
	subscriptionTranslate!: Subscription;
	translateSystemModules: translateSystemModules = {} as translateSystemModules;
	disabledRefresh = true;
	init: number = 0;
	end: number = 10;
	valueModalDelete = '';
	nameModal = '';
	versions: Versions[] = [];
	pageTo = 0;
	moduleDelete: Module = {} as Module;
	isLoadingCard = true;
	isLoading = true;
	statusSelect = true;
	moduleSelect: Module = {} as Module;
	classCard = 'card-module';
	classCardSelect = 'card-module-select ';
	filterResults: FilterValues[] = [] as FilterValues[];
	filterList: FilterList[] = filtersResourceTable;
	public filterSearch: string = '';

	tabs: Tabs[] = [
		{ value: 'resources', label: 'Resources' },
		{ value: 'versions', label: 'Versions' },
	];
	viewSelected = 'resources';
	columnsFilter: OptionsFilter[] = [
		{ name: 'name', label: 'Name' },
		{ name: 'action', label: 'Action' },
		{ name: 'path', label: 'Path' },
	];

	selector: string = '.container-cardModule';
	constructor(
		private store: Store,
		private translateService: TranslateService,
		public dialog: MatDialog,
		private filter: FilterTablePipe,
		private sort: SortPipe
	) {}
	ngOnInit() {
		this.store.dispatch(getAllModule());
		this.getModules();
		this.getTranslate();
	}

	getTranslate() {
		this.subscriptionTranslate = this.translateService.init('AccessControl').subscribe((data) => {
			this.translateSystemModules = data.pages.systemModules;
			this.filterList = this.translateSystemModules.searchTable as FilterList[];
			this.columnsFilter = this.translateSystemModules.columnsFilter;
			this.tabs = this.translateSystemModules.tabs;
			this.orderModules();
		});
	}

	selectedModule(module: Module) {
		this.moduleSelect = module;
		this.moduleSelect.pk = module.pk;
		this.store.dispatch(getResourcesModule({ url: module.relationships.self }));
		this.store.dispatch(
			getVersionsModule({ ids: { pk: module.pk, sk: module.sk }, page: 1, search: '' })
		);
	}

	onScroll() {
		if (this.paginationModule.next) {
			//this.store.dispatch(getModule({ pageTo: this.paginationModule.next }));
		}
	}
	openDialogModule(type: string = 'create', data = {}): void {
		const dialogRef = this.dialog.open(ModalNewModuleComponent, {
			height: '500px',
			width: '800px',
			data: { type, data },
		});
		dialogRef.afterClosed().subscribe((res) => {});
	}

	getModules() {
		this.subscriptionModule = this.store.pipe(select(setModule)).subscribe((state) => {
			this.isLoadingCard = state.loading;
			this.paginationModule = state.pagination;
			this.modules = state.modules.map((module) => {
				return {
					...module,
					logo: module?.logo ? module?.logo.replace('s3.amazonaws.com/', '') : '',
				};
			});
			this.isLoading = state.loadingResources;
			this.isLoadingVersions = state.loadingVersions;

			if (state.dataResources) {
				this.paginationResource = state.dataResources.pagination;
				this.rows = state.dataResources.resource;
				this.rowsFilter = this.rows;
				if (this.rowsFilter) {
					this.rowsFilter = [...this.rowsFilter];
				}
			}
			if (state.dataVersions) {
				this.paginationVersion = state.dataVersions.pagination;
				this.versions =
					state.dataVersions.versions.length > 0
						? [...state.dataVersions.versions]
						: state.dataVersions.versions;
			}
			this.orderModules();
			if (!this.moduleSelect?.pk && this.modules.length > 0) {
				this.selectedModule(this.modules[0]);
			}
		});
	}

	getFilterValues(filter: FilterValues[]) {
		this.filterResults = filter;
		this.rowsFilter = this.filter.transform(this.rows, filter) as Resource[];
	}

	openDialogResource(type = 'create', resource: Resource = {} as Resource): void {
		const dialogRef = this.dialog.open(ModalAddResourceComponent, {
			height: '620px',
			width: '600px',
			data: { module: this.moduleSelect, type, resource },
		});
		dialogRef.afterClosed().subscribe((res) => {});
	}
	searchSidebar(search: string) {
		this.store.dispatch(getSearchModule({ search }));
	}
	activeModalDelete(module: Module) {
		this.openAlert = true;
		this.nameModal = 'modalAlertDeleteElement';
		this.valueModalDelete = 'deleteModule';
		this.moduleDelete = module;
		this.elementsDelete = `${this.translateSystemModules.delete} '${module.name}'`;
	}

	orderModules() {
		this.modules = this.modules.map((module) => {
			if (this.moduleSelect.pk === module.pk) {
				this.moduleSelect = module;
			}
			return {
				...module,
				items: [
					{
						label: this.translateSystemModules.buttonEdit,
						icon: 'pi pi-pencil',
						command: () => {
							this.openDialogModule('update', module);
						},
					},
					{
						label: this.translateSystemModules.buttonDelete,
						icon: 'pi pi-trash',
						command: () => {
							console.log('delete');
							this.activeModalDelete(module);
						},
					},
				],
			};
		});
		this.modules = this.sort.transform(this.modules, 'name');
	}

	closeModalAlert(event: any) {
		this.openAlert = false;
		if (event.resp) {
			this.deleteModule(this.moduleDelete);
		}
		this.valueModalDelete = '';
		this.moduleDelete = {} as Module;
		this.nameModal = '';
		this.elementsDelete = '';
	}
	deleteModule(module: Module) {
		this.store.dispatch(deleteModule({ module }));
	}
	ngOnDestroy() {
		this.subscriptionCampagin?.unsubscribe();
		this.subscriptionTranslate?.unsubscribe();
		this.subscriptionModule?.unsubscribe();
		this.subscriptionResources?.unsubscribe();
	}
}
